import { useState, useEffect } from "react";

function useColorScheme () {
	const [ colorScheme, setColorScheme ] = useState ( null );

	useEffect ( () => {
		const mediaQuery   = window.matchMedia ( "(prefers-color-scheme: dark)" );
		const handleChange = () => {
	        setColorScheme ( mediaQuery.matches ? "dark" : "light" );
	      };

		handleChange ();
		mediaQuery.addListener ( handleChange );

		return () => {
	        mediaQuery.removeListener ( handleChange );
	      };
	}, [] );

	return colorScheme;
}

export default useColorScheme;
